import { render, staticRenderFns } from "./CustomerReturnPage.vue?vue&type=template&id=b0744546"
import script from "./CustomerReturnPage.vue?vue&type=script&lang=js"
export * from "./CustomerReturnPage.vue?vue&type=script&lang=js"
import style0 from "./include/customerReturnMecom.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports